import type { LauncherErrorKind } from "../services/launcher/types";

export const ERROR_MESSAGES: Record<LauncherErrorKind, string> = {
  userRejected: "You rejected the request in your wallet. Nothing was submitted.",
  wrongNetwork: "Wrong network. Switch your wallet to Robinhood Chain Testnet (chain 46630) and try again.",
  insufficientBalance: "Not enough ETH to cover the platform fee plus network gas.",
  factoryNotConfigured: "The testnet factory is not deployed yet, so deployment is disabled.",
  factoryPaused: "New launches are paused on the factory right now. Try again later.",
  bytecodeMismatch: "The factory at this address does not match the expected verified contract. Deployment is blocked for your safety.",
  reverted: "The transaction was confirmed as failed (reverted). No token was created.",
  replaced: "The transaction was replaced (sped up or cancelled) before confirming. Check your wallet and try again.",
  rpcError: "The network could not be reached. Check your connection and try again.",
  simulationRevert:
    "The launch was rejected during on-chain simulation, so no wallet request was made. This is a contract or configuration issue — not your connection. No token was created.",
  feeChanged: "The platform fee changed since you reviewed. Review the new amount and confirm again.",
  postVerificationFailed: "Transaction confirmed, but post-deployment verification failed. Do not treat this as a verified launch.",
  notOwner: "Only the current factory owner can change team access.",
  invalidAddress: "Enter a valid wallet address.",
  accountMismatch: "Your wallet's active account does not match the account in the app. Reconnect and try again.",
  zeroAddress: "The zero address cannot be used.",
  noChange: "That wallet is already in the requested state. No transaction is needed.",
  unknown: "Something went wrong. No token was created.",
};

export function messageFor(kind: LauncherErrorKind): string {
  return ERROR_MESSAGES[kind] ?? ERROR_MESSAGES.unknown;
}
